import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  IonButton,
  IonContent,
  IonModal,
  IonPage,
  IonRouterLink,
  IonTextarea,
} from "@ionic/react";

import "./OnCallLookUpPage.scss";
import { ReturnDataModel, SearchResultDataModel } from "./OnCallLookUpModel";
import { StorageService, utilService } from "../../services";
import OnCallLookUpMainContent from "./OnCallLookUpMainContent/OnCalllookUpMainContent";
import { CONSTANTS } from "../../constants";
import { AddFavoutiteModel } from "../OnCalllookUpFavorites/OnCallLookUpFavoriteModal";
import { OnCallLookUpService } from "../OnCalllookUpFavorites/OnCallLookUpService";
import { useToast } from "@agney/ir-toast";
import { onCallSearchResultService } from "./components/OnCallSearchResult/OnCallSearchResult.service";
import { useLocation } from "react-router-dom";
import _ from "lodash";
import classNames from "classnames/bind";
import { useNetwork } from "../../helpers/NetworkContext";
import { useFavNetwork } from "../../helpers/FavNetworkContext";

export interface ContainerProps {}

const OnCallLookUpMainPage: React.FC<ContainerProps> = (props) => {
  const { t } = useTranslation("onCallLookup");
  const { t: tSettings } = useTranslation("settings");
    const {selectedFavNetwork}:any = useFavNetwork();
     const {selectedNetwork}:any = useNetwork();
  const [canShowSearchByComp, setSearchByCompVisibillity] =
    useState<boolean>(false);
  const [canShowSearchResComp, setSearchResCompVisibility] =
    useState<boolean>(false);
  const [canShowInputComp, setInputCompVisibility] = useState<boolean>(true);
  const [dataFromInputComp, setInputCompData] =
    useState<ReturnDataModel>(Object);
  const [selectedGuid, setSelectedGuid] = useState<string>("");
  const [dataToSearchResComp, setDataToSearchResComp] =
    useState<SearchResultDataModel>(Object);
  const [screenType, setScreenType] = useState<string>("");
  const [resetSearchBy, setResetSearchBy] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  const [titleName, setTitleName] = useState<string>("");
  var [isInputEmpty, setIsInputEmpty] = useState(true);
  var [dataFromFavoriteCard, setDataFromFavoriteCard]: any = useState();
  var [isEdit, setIsEdit] = useState(false);
  const [text, setText] = useState<string>("");
  var [isEditInputEmpty, setIsEditInputEmpty] = useState(true);
  var [isSearchResultDisplayed, setIsSearchResultDisplayed] = useState(false);

  const Toast = useToast();
  const location:any = useLocation();

  useEffect(() => {
    setSearchByCompVisibillity(false);
    setSearchResCompVisibility(false);
    getScreenTypeString();
  }, []);

  useEffect(() => {
    if (!_.isEmpty(location.state)&&location?.state?.favCardData?.params?.hospital_id) {
      const currentLocation: any = location;
      setDataFromFavoriteCard(currentLocation.state.favCardData);
      setIsEdit(currentLocation.state.isEdit);
      setText(currentLocation.state.favCardData.title);
    }
  }, [location]);

  useEffect(() => {
    const resData: SearchResultDataModel = mapSelectedData();
    setDataToSearchResComp(resData);
    if (selectedGuid) {
      setSearchResCompVisibility(true);
      if (screenType === "small") {
        setSearchByCompVisibillity(false);
      }
    }
  }, [selectedGuid]);

  useEffect(() => {
    setSearchResCompVisibility(false);
  }, [dataFromInputComp]);

  const getScreenTypeString = () => {
    setScreenType(utilService.getScreenSize());
  };

  const mapSelectedData = () => {
    const returnFormat = {
      selectedUserid: selectedGuid,
      DateSelected: dataFromInputComp.DateSelected!,
      TimeSelected: dataFromInputComp.TimeSelected!,
      SiteSelected: dataFromInputComp.SiteSelected!,
      OptionSelected: dataFromInputComp.OptionSelected!,
    };
    return returnFormat;
  };

  const getResFromInputComp = (dataFromParent: ReturnDataModel) => {
    setInputCompData(dataFromParent);
    if (hasValue(dataFromParent)) {
      setSearchByCompVisibillity(true);
      if (screenType === "small") {
        setInputCompVisibility(false);
      }
    }
  };

  const checkIfInputEmpty = () => {
    const isWhitespace = utilService.checkIfInputEmpty("addFavText");
    setIsInputEmpty(isWhitespace);
  };

  const checkIfEditInputEmpty = () => {
    const isWhitespace = utilService.checkIfInputEmpty("editFavText");
    setIsEditInputEmpty(isWhitespace);
  };

  const hasValue = (data: ReturnDataModel) => {
    setResetSearchBy(false);
    if (
      (data.OptionSelected !== null || data.OptionSelected !== "") &&
      (data.DateSelected !== null || data.DateSelected !== "") &&
      (data.SiteSelected !== null || data.SiteSelected !== "") &&
      (data.TimeSelected !== null || data.TimeSelected !== "")
    ) {
      return true;
    }
    return false;
  };

  const addFavoriteList = async () => {
    const params = getAddFavListApiParams();
    const apiResponse: AddFavoutiteModel =
      await OnCallLookUpService.addOnCallFavoritesList(params);
    if (apiResponse.isSuccess) {
      Toast.success(tSettings("addedFavorite"));
    }
  };

  const editFavoriteListItem = async () => {
    const params = getAddFavListApiParams();
    const apiResponse: AddFavoutiteModel =
      await OnCallLookUpService.editOnCallFavoritesListItem(params);
    if (apiResponse.isSuccess) {
      Toast.success(CONSTANTS.MESSAGES.UPDATED_FAVORITE_SUCCESS);
    }
  };

  const getAddFavListApiParams = () => {
    const savePassword = utilService.getSavePasswordStatus();
    const userId = StorageService.getStorageItem(
      CONSTANTS.STORAGE[true === savePassword ? 1 : 0],
      "userId",
      true
    );
    const id = !_.isEmpty(dataFromFavoriteCard)
      ? dataFromFavoriteCard.id
      : undefined;
    const onCallSearchByData =
      onCallSearchResultService.getonCallSearchByListFromComponent();
    const onCallSearchResultData =
      onCallSearchResultService.getonCallSearchResultDataFromComponent();
    const siteId = onCallSearchResultService.getonCallSiteIdFromComponent();
    const siteList = onCallSearchResultService.getonCallSiteListFromComponent();
    const nameParamsData = setNameParamsFromIds(
      onCallSearchByData,
      onCallSearchResultData,
      siteId,
      siteList
    );

    return {
      reg_code: utilService.getNetwork(),
      n2n_network:selectedFavNetwork?.value ?? selectedNetwork?.value,
      title: titleName,
      user: userId,
      id: id,
      params: {
        network:selectedFavNetwork?.value ?? selectedNetwork?.value,
        network_id:selectedFavNetwork?.key ?? selectedNetwork?.key,
        date: onCallSearchResultData.date,
        group_id: onCallSearchResultData.group_id,
        guid: onCallSearchResultData.guid,
        hospital_id: onCallSearchResultData.hospital_id,
        hours: onCallSearchResultData.hours,
        minutes: onCallSearchResultData.minutes,
        speciality: onCallSearchResultData.speciality,
        nameParams: nameParamsData,
      },
    };
  };

  const setNameParamsFromIds = (
    onCallSearchByList: any,
    onCallSearchResultData: any,
    siteId: any,
    siteList: any
  ) => {
    const params = {
      site: siteList
        .filter((item: any) => item.dataId === siteId)
        .map((obj: any) => obj.dataName)[0],
      group: onCallSearchByList
        .filter((item: any) => item.id === parseInt(onCallSearchResultData.group_id))
        .map((obj: any) => obj.name)[0],
      speciality: onCallSearchByList
        .filter((item: any) => item.id === parseInt(onCallSearchResultData.speciality))
        .map((obj: any) => obj.name)[0],
      dr: onCallSearchByList
        .filter((item: any) => item.guid === onCallSearchResultData.guid)
        .map((obj: any) => obj.name)[0],
      userid: onCallSearchByList
        .filter((item: any) => item.guid === onCallSearchResultData.guid)
        .map((obj: any) => obj.id)[0],
      designation: onCallSearchByList
        .filter((item: any) => item.guid === onCallSearchResultData.guid)
        .map((obj: any) => obj.designation)[0],
    };
    return params;
  };

  const setSearchCompVisiblity = (dataFromProviderCard: any) => {
    if (dataFromProviderCard) {
      setIsSearchResultDisplayed(true);
    } else {
      setIsSearchResultDisplayed(false);
    }
  };

  const addFavBtnPadding = () => {
    if (screenType === "small") {
      return false;
    } else {
      return !(
        (!isEdit && isSearchResultDisplayed) ||
        (!_.isEmpty(dataFromFavoriteCard) && isEdit && isSearchResultDisplayed)
      );
    }
  };

  return (
    <IonPage>
      <IonContent>
        <div
          className={classNames({
            "ocl-main-container": true,
            "ocl-outer-padding": screenType !== "small" ? true : false,
            "ocl-main-cont-height": screenType === "small" ? true : false,
          })}
        >
          <div
            className={`addtofav-btn-container ${
              addFavBtnPadding() ? "addtofav-btn-padding" : ""
            }`}
          >
            {((!isEdit && isSearchResultDisplayed) ||
              (!_.isEmpty(dataFromFavoriteCard) &&
                isEdit &&
                isSearchResultDisplayed)) && (
              <IonButton
                onClick={() => {
                  !isEdit ? setShowModal(true) : setShowEditModal(true);
                }}
              >
                <div
                  className={classNames({
                    test: true,
                    "icon-add":
                      !isEdit && isSearchResultDisplayed ? true : false,
                    "icon-edit":
                      !_.isEmpty(dataFromFavoriteCard) && isEdit ? true : false,
                  })}
                ></div>
                {!isEdit && isSearchResultDisplayed && (
                  <span className="add-to-fav">{t("addToFavorite")}</span>
                )}
                {!_.isEmpty(dataFromFavoriteCard) && isEdit && (
                  <span className="add-to-fav">{t("editFavorite")}</span>
                )}
              </IonButton>
            )}

            {!_.isEmpty(dataFromFavoriteCard) &&
              isEdit &&
              screenType === "small" &&
              !isSearchResultDisplayed && (
                <IonButton
                  onClick={() => {
                    !isEdit ? setShowModal(true) : setShowEditModal(true);
                  }}
                >
                  <div
                    className={classNames({
                      test: true,
                      "icon-edit":
                        !_.isEmpty(dataFromFavoriteCard) && isEdit
                          ? true
                          : false,
                    })}
                  ></div>

                  {!_.isEmpty(dataFromFavoriteCard) && isEdit && (
                    <span className="add-to-fav">Edit favorite</span>
                  )}
                </IonButton>
              )}

            {/* {screenType === "small" && (
              <div
                className={classNames({
                  "ocl-fav-btn": true,
                })}
              >
                <IonRouterLink routerLink="/client/favorites">
                  <IonButton className="fav-btn-div ">
                    <span className="icon-show_password"></span>
                    <span></span>
                  </IonButton>
                </IonRouterLink>
              </div>
            )} */}
          </div>

          <OnCallLookUpMainContent
            favCardData={dataFromFavoriteCard}
            updateProviderList={() => {}}
            showSearchResult={() => {}}
            isResultPageDisplayed={setSearchCompVisiblity}
          />
        </div>

        <IonModal
          isOpen={showModal}
          backdropDismiss={false}
          className="add-oc-fav-modal"
        >
          <div className="label-div">
            <div className="label-name">{t("addToFavorite")}</div>
            <div
              className="input-icon icon-close"
              onClick={() => {
                
                setShowModal(false);
                setTitleName("");
              }}
            ></div>
          </div>
          <div className="title-name-container">
            <div className="title-name-label">{t("titleName", "Title Name")}</div>
          </div>

          <div className="add-fav-text-box">
            <IonTextarea
              className="textarea-div"
              placeholder={t("enterTitleName", "Enter a title name")}
              id="addFavText"
              value={titleName}
              onIonChange={(e) => {
                checkIfInputEmpty();
                setTitleName(e.detail.value!);
              }}
            ></IonTextarea>
          </div>

          <div className="add-fav-button-container">
            <div className="cancel-button-div">
              <IonButton
                color="medium"
                className="button secondary-btn  btn-curved"
                onClick={() => {
                  setTitleName("");
                }}
              >
                {t("clear", "Clear")}
              </IonButton>
            </div>
            <div className="send-button-div">
              <IonButton
                disabled={isInputEmpty}
                className="submit-btn button primary-btn btn-curved"
                onClick={() => {
                  addFavoriteList();
                  setShowModal(false);
                  setTitleName("");
                }}
              >
                {t("add", "Add")}
              </IonButton>
            </div>
          </div>
        </IonModal>
        <IonModal
          isOpen={showEditModal}
          backdropDismiss={false}
          className="add-oc-fav-modal"
        >
          <div className="label-div">
            <div className="label-name">{t("editFavorite", "Edit favorite")}</div>
            <div
              className="input-icon icon-close"
              onClick={() => {
                setShowEditModal(false);
                setTitleName("");
              }}
            ></div>
          </div>
          <div className="title-name-container">
            <div className="title-name-label">{t("titleName", "Title Name")}</div>
          </div>

          {!_.isEmpty(dataFromFavoriteCard) && (
            <div className="add-fav-text-box">
              <IonTextarea
                className="textarea-div"
                placeholder={t("enterTitleName", "Enter a title name")}
                id="editFavText"
                value={titleName}
                onIonChange={(e) => {
                  checkIfEditInputEmpty();
                  setTitleName(e.detail.value!);
                  setText(e.detail.value!);
                }}
              ></IonTextarea>
            </div>
          )}

          <div className="add-fav-button-container">
            <div className="cancel-button-div">
              <IonButton
                color="medium"
                className="button secondary-btn  btn-curved"
                onClick={() => {
                  setTitleName("");
                }}
              >
                {t("clear", "Clear")}
              </IonButton>
            </div>
            <div className="send-button-div">
              <IonButton
                disabled={isEditInputEmpty}
                className="submit-btn button primary-btn btn-curved"
                onClick={() => {
                  editFavoriteListItem();
                  setShowEditModal(false);
                  setTitleName("");
                }}
              >
                {t("edit", "Edit")}
              </IonButton>
            </div>
          </div>
        </IonModal>
      </IonContent>
    </IonPage>
  );
};

export default OnCallLookUpMainPage;
